module.exports = __webpack_public_path__ + "static/img/incheon-ag-tech.865555d.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/visual-marketing-detail/incheon-ag-tech.jpg
// module id = ROJG
// module chunks = 0